import { classNames } from '../../utils/style';
import React from 'react';

export interface HighlightedBorderProps {
  highlightedBorder: string;
  className?: string;
}

export const HighlightedBorder = ({
  highlightedBorder,
  className,
}: HighlightedBorderProps) =>
  highlightedBorder && (
    <div
      className={classNames(className, 'absolute top-[-34px] left-0 right-0')}
    >
      <div className="w-full text-center bg-blue-101 leading-[34px] rounded-t-18 text-white h-[34px]">
        {highlightedBorder}
      </div>
    </div>
  );
